module.exports = __webpack_public_path__ + "static/media/maternity6.90b6ec23.jpg";